<template>
  <div class="banner-gsap">
    <svg class="main1" width="100%" height="100%" style="opacity: 1; visibility: inherit;">
      <defs>
        <linearGradient id="grad1" x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="10%" style="stop-color:rgb(23, 82, 252);stop-opacity:0.9"></stop>
          <stop offset="99%" style="stop-color:rgb(23, 82, 252);stop-opacity:0.1"></stop>
        </linearGradient>
        <linearGradient id="grad2" x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="25%" style="stop-color:rgb(23, 82, 252);stop-opacity:0.1"></stop>
          <stop offset="99%" style="stop-color:rgb(23, 82, 252);stop-opacity:0.2"></stop>
        </linearGradient>
      </defs>

      <!-- <rect class="m1Bg" fill="url(#grad2)" width="100%" height="100%" style="opacity: 1;"></rect> -->

      <g class="m1_stage" opacity="0" data-svg-origin="-165 -148.341064453125" transform="matrix(1,0,0,1,641.5,0)" style="transform-origin: 0px 0px; opacity: 1;">
        <g class="m1_cGroup" data-svg-origin="0 105.56842041015625" transform="matrix(1,0.00055,-0.00055,1,147.6206,0.3025)" style="opacity: 1; transform-origin: 0px 0px;">
          <circle class="m1OrbBlank" cx="0" cy="50" r="50" fill="#1290ff" data-svg-origin="-670 0" transform="matrix(-0.31289,0.94979,-0.94979,-0.31289,-259.6363,636.3593)" style="opacity: 0.3605; transform-origin: 0px 0px;"></circle>

          <circle class="c1_line c1_line4" cx="0" cy="50" r="550" fill="none" stroke-width="2" stroke="url(#grad1)" opacity="0.8811"></circle>
          <g class="m1Orb orb4b" data-svg-origin="20 20" transform="matrix(1.5,0,0,1.5,-60.46962,88.72498)" style="transform-origin: 0px 0px;">
            <image xlink:href="@/assets/svg/BTC.svg" width="40" height="40"></image>
          </g>

          <g class="m1Orb orb4" data-svg-origin="15 10.5" transform="matrix(1.5,0,0,1.5,302.38498,474.87665)" style="transform-origin: 0px 0px;">
            <circle cx="15" cy="10.5" r="20" fill="#006bca"></circle>
            <text font-size="14" fill="#fff" style="font-weight:900;transform: translate(2px, 14px);font-family: Medium;">BTC</text>
          </g>
        </g>
        <g class="m1_cGroup" data-svg-origin="49.97412109375 50" transform="matrix(1,0.00055,-0.00055,1,73.7278,-5.5886)" style="opacity: 1; transform-origin: 0px 0px;">
          <circle class="m1OrbBlank" cx="0" cy="50" r="25" fill="#983334" data-svg-origin="-550 25" transform="matrix(0.99991,-0.01338,0.01338,0.99991,524.616,-7.35675)" style="opacity: 0.3605; transform-origin: 0px 0px;"></circle>

          <circle class="c1_line c1_line3" cx="0" cy="50" r="450" fill="none" stroke-width="2" stroke="url(#grad1)" opacity="0.8811"></circle>

          <g class="m1Orb orb3c" data-svg-origin="20 20" transform="matrix(1.5,0,0,1.5,-211.77401,-461.83217)" style="transform-origin: 0px 0px;">
            <circle cx="12.5" cy="7" r="17" fill="#653997"></circle>
            <circle cx="12.5" cy="7" r="20" fill="none" stroke="#653997"></circle>
            <text font-size="12" fill="#fff" style="font-weight:900;transform: translate(1px, 11px);font-family: Medium;">ETH</text>
          </g>

          <g class="m1Orb orb3b" data-svg-origin="20 20" transform="matrix(1.5,0,0,1.5,-279.99991,159.71544)" style="transform-origin: 0px 0px;">
            <image xlink:href="@/assets/svg/ETH.svg" width="40" height="40"></image>
          </g>
          <g class="m1Orb orb3" data-svg-origin="20 8" transform="matrix(1.5,0,0,1.5,-465.85563,245.43912)" style="transform-origin: 0px 0px;">
            <circle cx="20" cy="8" r="24" stroke="#bc7c00" stroke-width="3" fill="#cc971b"></circle>
            <text font-size="14" fill="#fff" style="font-weight:900;transform: translate(6px, 13px);font-family: Medium;">BTC</text>
          </g>
        </g>
        <g class="m1_cGroup" data-svg-origin="0 59.508209228515625" transform="matrix(1,0.00055,-0.00055,1,49.128,-11.4743)" style="opacity: 1; transform-origin: 0px 0px;">
          <circle class="m1OrbBlank" cx="0" cy="50" r="15" fill="#653997" data-svg-origin="-445 35" transform="matrix(0.4347,0.90057,-0.90057,0.4347,209.96145,420.53915)" style="opacity: 0.3605; transform-origin: 0px 0px;"></circle>

          <circle class="c1_line c1_line2" cx="0" cy="50" r="360" fill="none" stroke-width="2" stroke="url(#grad1)" opacity="0.8811"></circle>

          <g class="m1Orb orb2" data-svg-origin="18.5 7" transform="matrix(1.5,0,0,1.5,128.44551,27.93715)" style="transform-origin: 0px 0px;">
            <circle cx="18.5" cy="7" r="24.5" fill="#983334" stroke-width="2.5" stroke="#b9393a"></circle>
            <text font-size="14" fill="#fff" style="font-weight:900;transform: translate(0px, 12px);font-family: Medium;">USDT</text>
          </g>
        </g>
        <g class="m1_cGroup" data-svg-origin="0 76.19189453125" transform="matrix(1,0.00055,-0.00055,1,36.8474,-17.3544)" style="opacity: 1; transform-origin: 0px 0px;">
          <circle class="m1OrbBlank" cx="0" cy="50" r="20" fill="#653997" data-svg-origin="-355 30" transform="matrix(-0.48837,0.87264,-0.87264,-0.48837,-167.19215,354.4383)" style="opacity: 0.3605; transform-origin: 0px 0px;"></circle>
          <circle class="m1OrbBlank" cx="0" cy="50" r="40" fill="rgba(125,200,32,0.19)" data-svg-origin="-280 10" transform="matrix(-0.63248,0.77457,-0.77457,-0.63248,-209.3487,233.2044)" style="opacity: 0.3605; transform-origin: 0px 0px;"></circle>

          <circle class="c1_solid" cx="0" cy="50" r="280" fill="url(#grad1)" opacity="0.8811"></circle>
          <circle class="c1_line c1_line1" cx="0" cy="50" r="279" fill="none" stroke-width="3" stroke="url(#grad1)" opacity="0.8811"></circle>
          <g class="m1Orb orb1" data-svg-origin="12.5 7" transform="matrix(1.5,0,0,1.5,-249.09143,317.54177)" style="transform-origin: 0px 0px;">
            <image xlink:href="@/assets/svg/USDT.svg" width="40" height="40"></image>
          </g>
        </g>
        <g class="m1_cGroup" data-svg-origin="0 50" transform="matrix(1,0.00055,-0.00055,1,29.4856,-23.2236)" style="opacity: 1; transform-origin: 0px 0px;">
          <circle class="c1_solid" cx="0" cy="50" r="220" fill="url(#grad1)" opacity="0.8811"></circle>
        </g>
        <g class="m1_cGroup" data-svg-origin="0 50" transform="matrix(1,0.00055,-0.00055,1,24.5943,-29.0982)" style="opacity: 1; transform-origin: 0px 0px;">
          <circle class="c1_solid" cx="0" cy="50" r="150" fill="url(#grad1)" opacity="0.8811"></circle>
        </g>
        <g class="m1_cGroup" data-svg-origin="0 50" transform="matrix(1,0.00055,-0.00055,1,21.1114,-34.9728)" style="opacity: 1; transform-origin: 0px 0px;">
          <circle class="c1_solid" cx="0" cy="50" r="80" fill="rgb(23, 82, 252)" opacity="0.8811"></circle>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
const gsap = window.gsap;
const $ = window.$;

export default {
  name: 'banner-gsap',
  created() {
    if (document.location.search.match(/type=embed/gi)) {
      window.parent.postMessage('resize', '*');
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      window.onload = () => {
        gsap.set('.m1_stage', { x: '50%', opacity: 1 });
      };
      gsap.timeline({
        defaults: {
          duration: 45,
        },
      })
        .from('.main1', {
          duration: 1,
          autoAlpha: 0,
          ease: 'power1.inOut',
        }, 0)
        .fromTo('.m1_cGroup', {
          opacity: 0,
        },
        {
          duration: 0.3,
          opacity: 1,
          stagger: -0.1,
        }, 0)
        .from('.m1_cGroup', {
          duration: 2.5,
          scale: -0.3,
          transformOrigin: '50% 50%',
          stagger: -0.05,
          ease: 'elastic',
        }, 0)
        // fromTo('.m1Bg', { opacity: 0 }, { duration: 1, opacity: 1, ease: 'power2.inOut' }, 0.2).
        .add('orbs', 1.2)
        .add(this.mainAddFn(), 'orbs+=0.5')
        .fromTo('.orb1', {
          xPercent: -35,
          yPercent: -5,
        },
        {
          motionPath: {
            path: this.orb4bFn('.c1_line1'),
            start: 1.03,
            end: 1.22,
          },
          ease: 'none',
          yoyo: true,
          repeat: -1,
        }, 'orbs')
        .fromTo('.orb2', {
          xPercent: -45,
          yPercent: -10,
        },
        {
          motionPath: {
            path: this.orb4bFn('.c1_line2'),
            start: 0.98,
            end: 1.2,
          },
          ease: 'none',
          yoyo: true,
          repeat: -1,
        }, 'orbs')
        .fromTo('.orb3', {
          xPercent: -50,
          yPercent: -15,
        },
        {
          motionPath: {
            path: this.orb4bFn('.c1_line3'),
            start: 1.06,
            end: 1.31,
          },
          ease: 'none',
          yoyo: true,
          repeat: -1,
        }, 'orbs')
        .fromTo('.orb3b', {
          xPercent: -50,
          yPercent: -25,
        },
        {
          motionPath: {
            path: this.orb4bFn('.c1_line3'),
            start: 1.49,
            end: 1.65,
          },
          ease: 'none',
          yoyo: true,
          repeat: -1,
        }, 'orbs')
        .fromTo('.orb3c', {
          xPercent: -45,
          yPercent: -15,
        },
        {
          motionPath: {
            path: this.orb4bFn('.c1_line3'),
            start: 0.95,
            end: 1.2,
          },
          ease: 'none',
          yoyo: true,
          repeat: -1,
        }, 'orbs')
        .fromTo('.orb4', {
          xPercent: -50,
          yPercent: -25,
        },
        {
          motionPath: {
            path: this.orb4bFn('.c1_line4'),
            start: 1.14,
            end: 1.26,
          },
          ease: 'none',
          yoyo: true,
          repeat: -1,
        }, 'orbs')
        .fromTo('.orb4b', {
          xPercent: -50,
          yPercent: -25,
        },
        {
          motionPath: {
            path: this.orb4bFn('.c1_line4'),
            start: 1.41,
            end: 1.6,
          },
          ease: 'none',
          yoyo: true,
          repeat: -1,
        }, 'orbs')
        .fromTo('.m1Orb', {
          scale: 0,
          transformOrigin: '50% 50%',
        },
        {
          duration: 0.8,
          scale: 1.5,
          ease: 'back.out(3)',
          stagger: 0.15,
          overwrite: 'auto',
        }, 'orbs')
        .fromTo('.m1OrbBlank', {
          opacity: 0,
        },
        {
          duration: 0.8,
          opacity: i => this.opacityFn(i),
          stagger: 0.1,
          overwrite: 'auto',
        }, 'orbs')
        .fromTo('.m1OrbBlank', {
          x: i => this.xFn(i),
          transformOrigin: i => this.transformOriginFn(i),
          rotation: i => this.rotationFn(i),
        },
        {
          rotation: '+=75',
          yoyo: true,
          repeat: -1,
        }, 'orbs');
    },
    mainAddFn() {
      $('.main1').on('mousemove', (e) => {
        gsap.to('.m1_cGroup', {
          duration: 1,
          x: i => this.m1GroupXFn(i, e),
          y: i => this.m1GroupYFn(i, e),
          rotation: Math.random() * 0.1,
          overwrite: 'auto',
        });
        gsap.to('.c1_solid, .c1_line', {
          duration: 1,
          attr: {
            opacity: 1.1 - 0.75 * (e.clientY / window.innerHeight),
          },
        });
        gsap.to('.m1OrbBlank', {
          duration: 1,
          opacity: 0.2 + 0.55 * (e.clientY / window.innerHeight),
        });
      });
      $('.main1').on('click', () => {
        if (gsap.getProperty('.m1_cGroup', 'scale') !== 1) return; // prevent overlapping bouncy tweens
        for (let i = 0; i < $('.m1_cGroup').length; i += 1) {
          if (window.CP.shouldStopExecution(0)) break;
          gsap.fromTo($('.m1_cGroup')[i], {
            transformOrigin: '50% 50%',
            scale: 1,
          },
          {
            duration: 0.7 - i / 25,
            scale: 0.9,
            ease: 'back.in(10)',
            yoyo: true,
            repeat: 1,
          });
        }
        window.CP.exitedLoop(0);
      });
    },
    m1GroupXFn(i, e) {
      return e.clientX / window.innerWidth / (i + 1) * 150;
    },
    m1GroupYFn(i, e) {
      return i * -20 * (e.clientY / window.innerHeight);
    },
    orb4bFn(str) {
      return window.MotionPathPlugin.convertToPath(str, false)[0];
    },
    opacityFn(i) {
      return 0.2 + i / 7;
    },
    xFn(i) {
      return 620 - i / 4 * 380;
    },
    transformOriginFn(i) {
      return `${-(620 - i / 4 * 380)}px 0px`;
    },
    rotationFn(i) {
      return [99, -10, 55, 110, 120][i];
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-gsap {
  width:100%;
  height:100%;
  overflow:hidden;
}
</style>
